import {
  jwtAuthAxios,
  optionalAuthAxios,
} from "../../shared/utils/network-utils";
import { MergeHlaWayInto } from "../models/MergeHlaWayInto";
import { CreateHlaWay, HlaWay, UpdateHlaWay } from "../models/HlaWay";

const prefix = "/hla-ways";

export const HlaWayApi = {
  get: async (hlaWayId: string) =>
    await optionalAuthAxios().get<HlaWay>(`${prefix}/${hlaWayId}`),

  update: async (hlaWayId: string, body: UpdateHlaWay) => {
    return await jwtAuthAxios().put<HlaWay>(`${prefix}/${hlaWayId}`, body);
  },

  create: async (body: CreateHlaWay) => {
    return await jwtAuthAxios().post<HlaWay>(`${prefix}`, body);
  },

  mergeInto: async (hlaWayId: string, body: MergeHlaWayInto) => {
    return await jwtAuthAxios().post<HlaWay>(
      `${prefix}/${hlaWayId}/merge-into`,
      body,
    );
  },

  delete: async (hlaWayId: string) => {
    return await jwtAuthAxios().delete(`${prefix}/${hlaWayId}`);
  },
};
